import angular from 'angular';
import moment from 'moment';

const isGMValid = (gm, fiscalYearEnd) =>
  !gm || //Empty is valid
  (!moment(gm).isBefore(moment(fiscalYearEnd)) && //Not before end fiscal year
    !moment(gm).isAfter(
      moment(fiscalYearEnd)
        .clone()
        .add(6, 'months')
        .endOf('month'),
    )); //Max 6 months after end fiscal year

angular
  .module('cloudX')
  .controller('FiscalYearDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    'resourceFactorySvc',
    '$element',
    'close',
    'relationId',
    'gmType',
    'relPersistSvc',
    'checkTenantConfiguration',
    fiscalYearDialogCtrl,
  ]);

function fiscalYearDialogCtrl(
  $http,
  appUrls,
  flySvc,
  resourceFactorySvc,
  $element,
  close,
  relationId,
  gmType,
  relPersistSvc,
  checkTenantConfiguration,
) {
  var vm = this;
  vm.lines = null;
  vm.showHistory = false;
  vm.reloadRelationData = false;
  vm.gmType = gmType;
  const isNetherlandsConfiguration = checkTenantConfiguration('[5]');

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };
  var parseDate = date => (!date ? null : moment(date.substr(0, 10)).toDate());

  var mapLine = x => {
    var line = {
      ...x,
      fiscalYearStart: parseDate(x.fiscalYearStart),
      fiscalYearEnd: parseDate(x.fiscalYearEnd),
      generalMeeting: parseDate(x.generalMeeting),
      generalMeetingPostponed: parseDate(x.generalMeetingPostponed),
    };
    line.invalidGM =
      !isNetherlandsConfiguration && !isGMValid(line.generalMeeting, line.fiscalYearEnd);
    line.invalidGMPostponed =
      !isNetherlandsConfiguration && !isGMValid(line.generalMeetingPostponed, line.fiscalYearEnd);

    return line;
  };

  vm.retrieve = function() {
    return $http
      .get(appUrls.api + '/Api/FiscalYear/' + relationId, { params: { history: vm.showHistory } })
      .then(
        function({ data }) {
          vm.lines = data.map(mapLine);
        },
        function(error) {
          vm.lines = [];
          showError(error);
        },
      );
  };

  vm.submit = function(line, value, field) {
    if (field !== 'locked' && field !== 'generalMeetingPostponed' && field !== 'generalMeeting')
      return false;
    if (field === 'generalMeeting' && vm.gmType !== 3) return false;
    if (field === 'generalMeetingPostponed' && typeof value === 'undefined') return ''; //invalid date
    if (field === 'generalMeeting' && typeof value === 'undefined') return ''; //invalid date
    var copy = angular.copy(line);
    copy[field] = value;
    copy = resourceFactorySvc.setDatePropsToISO(copy);
    return $http.put(appUrls.api + '/Api/FiscalYear/Put', copy).then(function({ data }) {
      angular.extend(line, mapLine(data));
      if (field === 'generalMeetingPostponed' || field === 'generalMeeting')
        vm.reloadRelationData = true;
      return false;
    }, showError);
  };
  vm.getPostponedDateOptions = function(line) {
    var maxDate = moment(line.fiscalYearEnd)
      .clone()
      .add(6, 'month')
      .toDate();

    var minDate = moment(line.fiscalYearEnd)
      .clone()
      .add(1, 'day')
      .toDate();

    const initialDate = line.generalMeeting ? new Date(line.generalMeeting) : minDate;
    return {
      initDate: initialDate,
      minDate: minDate,
      maxDate: maxDate,
      startingDay: 1,
    };
  };
  vm.getGMDateOptions = function(line) {
    var maxDate = moment(line.fiscalYearEnd)
      .clone()
      .add(6, 'month')
      .toDate();
    var minDate = moment(line.fiscalYearEnd)
      .clone()
      .add(1, 'day')
      .toDate();

    return {
      initDate: minDate,
      minDate: minDate,
      maxDate: maxDate,
      startingDay: 1,
    };
  };
  vm.getEFYDateOptions = function(line) {
    var maxDate = moment(line.fiscalYearEnd)
      .clone()
      .add(1, 'year')
      .toDate();

    return {
      initDate: line.fiscalYearEnd,
      minDate: line.fiscalYearStart,
      maxDate: maxDate,
      startingDay: 1,
    };
  };
  vm.retrieveHistory = function() {
    vm.showHistory = true;
    return vm.retrieve();
  };
  vm.updateEndFiscalYear = function(line, newDate) {
    if (!newDate) return '';
    if (newDate === line.fiscalYearEnd) return false;
    var mDate = moment.utc(newDate);
    if (!mDate.isValid()) return '';
    if (mDate.isBefore(moment.utc(line.fiscalYearStart))) return '';
    if (
      mDate.isAfter(
        moment
          .utc(line.fiscalYearEnd)
          .clone()
          .add(1, 'year'),
      )
    )
      return '';
    return $http
      .put(appUrls.api + '/Api/FiscalYear/EndFiscalYear', {
        relationId,
        year: line.fiscalYear,
        endFiscalYear: mDate.toDate().ISO(),
        fiscalYearId: line.id,
      })
      .then(
        function({ data }) {
          vm.lines = data.map(mapLine);
          vm.showHistory = true; //Update returns all lines

          vm.reloadRelationData = true;
          relPersistSvc.recalcFiscalYearDeadlines(relationId);
          return false;
        },
        function(error) {
          showError(error);
          return '';
        },
      );
  };

  vm.retrieve();

  vm.cancel = function() {
    close(vm.reloadRelationData, 500);
  };
}
